<template>
  <div
    :class="{ 'ai-fab': true, 'ai-fab-400': showAi }"
    id="aiFab"
    @click="openAi"
  >
    <span class="icon-white"></span>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
    },
  },
  watch: {
    show() {
      this.showAi = this.show
    },
  },
  data() {
    return {
      showAi: false,
    }
  },
  methods: {
    openAi() {
      this.showAi = !this.showAi
      this.$emit('onVisiable', this.showAi)
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
}
</script>

<style lang="less" scoped>
/* AI助手悬浮按钮 */
.ai-fab {
  position: fixed;
  right: 24px;
  &.ai-fab-400 {
    right: 420px;
  }
  bottom: 24px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  border: none;
  font-size: 24px;
  background-color: transparent;
  // box-shadow: 0px 0px 10px 3px #9ecffc;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon-white {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: url('../../assets//images/AI/AI_icon.svg') no-repeat center;
    background-size: 95px;
    // transform: scale(1.15);
  }
}

.ai-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.6);
}

.ai-fab:active {
  transform: scale(0.95);
}

.ai-fab.active {
  background: linear-gradient(135deg, #096dd9 0%, #0050b3 100%);
}
</style>
